import React, { useState, useEffect } from 'react'
import Stories from './Stories'
import GoogleMaps from './GoogleMaps'


function Map(props){

    const { app, showStory, viewStoryClicked, mapStyle } = props

    const [data, setData] = useState([])
    const [allStories, setAllStories] = useState(props.stories)
    const [stories, setStories] = useState(props.stories)



    useEffect(() => {
        if(props.allStories.length > 0){
            setAllStories(props.allStories)
            setStories(props.allStories)
            const data = getUniqueLocations(props.allStories)
            setData(data)
        }
        // eslint-disable-next-line
    }, [props.allStories]);

    const getUniqueLocations = (stories) => {

      const arr = []

      for (let index = 0; index < stories.length; index++) {
        const story = stories[index]
        const location = story.location
        if(locationNull(location)) continue
        const locationIndex = locationAlreadyExists(arr, location)
        if(locationIndex === -1){ // location does not exist
          const storiesArray = []
          storiesArray.push(story)
          arr.push({
            location: {...location},
            stories: storiesArray
          })
        }else{
          arr[locationIndex].stories.push(story)
        }
      }

      return arr

    }

      
    const locationNull = (location) => {
      return location.lat === null || location.lat === undefined ||
      location.lng === null|| location.lng === undefined
    }

    const locationAlreadyExists = (arr, location) => {
      for (let index = 0; index < arr.length; index++) {
        const l = arr[index].location
        if(l.lat === location.lat && l.lng === location.lng){
          return index
        }
      }
      return -1
    }


    const handleOnDragEnd = (props) => {

      const { bounds } = props
        
        const stories = allStories.filter(story => {
          const location = story.location
          return location.lat <= bounds.nw.lat &&
            location.lat >= bounds.sw.lat &&
            location.lng <= bounds.ne.lng &&
            location.lng >= bounds.nw.lng
        })
    
        setStories(stories)
    }


    return (
        <>
        <GoogleMaps 
            app={app}
            data={data}
            onDragend={handleOnDragEnd}
            viewStoryClicked={viewStoryClicked}
            mapStyle={mapStyle} />
        <div style={{marginTop: 20, marginBottom: 65}}>
            <Stories stories={stories} showStory={showStory} />
        </div>
        </>
    )
}

export default Map